import { useEffect, useRef } from 'react';

export default function HeroSection() {
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    const el = titleRef.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(32px)';
    const t = setTimeout(() => {
      el.style.transition = 'opacity 0.9s ease, transform 0.9s ease';
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }, 200);
    return () => clearTimeout(t);
  }, []);

  const handleScrollDown = () => {
    const el = document.querySelector('#about');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="header"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/e1db8ea739be7b97f5fb22daa432210d.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full flex flex-col items-center text-center px-6 md:px-10 pt-20">
        {/* Pill badge */}
        <div className="inline-flex items-center gap-2 border border-white/30 rounded-full px-4 py-1.5 mb-10 backdrop-blur-sm bg-white/5">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
          <span className="text-xs font-medium text-white/80 tracking-widest uppercase">iOS Platform Experts</span>
        </div>

        {/* Main Headline */}
        <h1 ref={titleRef} className="text-5xl md:text-7xl lg:text-8xl font-thin text-white leading-tight max-w-5xl">
          Redefining
          <br />
          <span className="font-semibold text-emerald-400">Mobile Security</span>
          <br />
          &amp; Performance
        </h1>

        {/* Subtitle */}
        <p className="mt-8 text-lg md:text-xl text-white/70 font-light max-w-xl leading-relaxed">
          Expert-crafted iOS applications designed to protect your privacy
          and keep your device running at its best.
        </p>

        {/* Scroll Indicator */}
        <button
          onClick={handleScrollDown}
          className="mt-20 flex flex-col items-center gap-2 cursor-pointer group"
          aria-label="Scroll down"
        >
          <span className="text-xs text-white/40 tracking-widest uppercase">Scroll</span>
          <div className="w-px h-12 bg-gradient-to-b from-white/40 to-transparent group-hover:from-emerald-400 transition-all duration-300" />
          <i className="ri-arrow-down-line text-white/40 group-hover:text-emerald-400 transition-colors duration-300" />
        </button>
      </div>
    </section>
  );
}
